export class AddAdditionalEmailToUser {
    static readonly type = '[User] AddAdditionalEmailToUser';

    constructor(public payload: { email: string; userId: string }) {}
}
